import { useMemo } from "react";
import useLeaderboardListCategories from "../hooks/useLeaderboardListCategories";
import useLeaderboardOrdinationStore from "../store/leaderboardOrdinatinoStore";
import "./LeaderboardSelector.css";

const LeaderboardTabs = () => {
  const { data: medals, isLoading } = useLeaderboardListCategories();
  const setFieldOrder = useLeaderboardOrdinationStore(
    (state) => state.setFieldOrder,
  );
  const currentFieldOrder = useLeaderboardOrdinationStore(
    (state) => state.fieldOrder,
  );

  const availableTabs = useMemo(() => {
    if (!medals) return [];
    const groups = new Set(["Overall"]);
    medals.map((m) => m.medalType?.name || "Others").forEach((name) => groups.add(name));
    return Array.from(groups);
  }, [medals]);

  const activeTab = useMemo(() => {
    if (currentFieldOrder.startsWith("Total_"))
      return currentFieldOrder.replace("Total_", "");
    if(currentFieldOrder === "Overall") return "Overall";
    const activeMedal = medals?.find((m) => m.name === currentFieldOrder);
    return activeMedal?.medalType?.name || availableTabs[0] || "";
  }, [currentFieldOrder, medals, availableTabs]);

  if (isLoading) return null;

  return (
    <div className="tabs-header">
      {availableTabs.map((tab) => (
        <button
          key={tab}
          className={`tab-btn ${activeTab === tab ? "active" : ""}`}
          onClick={() => setFieldOrder(tab === "Overall" ? "Overall" : `Total_${tab}`)}
        >
          {tab}
        </button>
      ))}
    </div>
  );
};

export default LeaderboardTabs;
